import React, { useState } from "react";
import SideBar from "../../components/sidebar/Sidebar";
import { Box, Fab, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddCardIcon from "@mui/icons-material/AddCard";
import ContrattiTableComponent from "../../components/contratto/ContrattiTableComponent";
import "./Contratto.scss";
import ExcelExportButton from "../../components/shared/ExcelExportButton";
import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "react-query";
import { fetchSelectContratti } from "../../api/contratto";
import { fetchContractsQueryKey } from "../../utils/QueryClient";
import { FetchPaginatedApiModel } from "../../models/shared/CommonModels";
import { ContrattoConStatoTipologia } from "../../models/ContrattoModel";

const ContrattoPage: React.FC<{}> = () => {

  const [fabVisible, setFabVisible] = useState(true)
  const [contratti, setContratti] = useState<FetchPaginatedApiModel<ContrattoConStatoTipologia[]>>(undefined as any)
  
  useQuery({
    queryKey: [fetchContractsQueryKey],
    queryFn: () => fetchSelectContratti(0, undefined, { id: 0, field: "id", direction: "asc" }, -1),
    onSuccess: (getResponse) => {
      setContratti(getResponse.data);
    },
    refetchOnWindowFocus: false,
  });

  const excelColumns: GridColDef[] = [
    { field: "id", headerName: "ID Contratto", width: 110 },
    { field: "cognome", headerName: "Cognome", width: 150 },
    { field: "nome", headerName: "Nome", width: 150 },
    { field: "titolo", headerName: "Titolo", width: 200 },
    { field: "stato", headerName: "Stato del Contratto", width: 150 },
    { field: "tipologia", headerName: "Tipologia del Contratto", width: 180 },
  ];

  const excelRows = contratti?.data?.map(contratto => ({
    id: contratto.id,
    cognome: "-",
    nome: "-",
    titolo: contratto.titolo || "-",
    stato: contratto.statocontratto?.nome || "-",
    tipologia: contratto.tipologiacontratto?.nome || "-",
  })) || [];

  return (
    <div className="home">
      {fabVisible &&
        <Fab
          onClick={() => setFabVisible(false)}
          sx={{ position: "fixed", bottom: 16, right: 16 }} color="primary" aria-label="add">
          <AddIcon />
        </Fab>
      }
      <SideBar />
      <div className="homeContainer">
        <Box sx={{ mb: 3 }}>
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 2,
            mb: 2,
            pb: 2,
            borderBottom: "2px solid",
            borderColor: "primary.main"
          }}>
            <AddCardIcon sx={{ fontSize: 40, color: "primary.main" }} />
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 600,
                color: "primary.main",
                letterSpacing: "0.5px"
              }}
            >
              Contratti
            </Typography>
          </Box>
        </Box>
        <ContrattiTableComponent
          alterFabVisibility={setFabVisible}
          fabVisible={fabVisible}
          enableCreate={true}
          anagrafica_cliente_id={-1}
          toolbarActions={
            <ExcelExportButton 
              columns={excelColumns}
              rows={excelRows}
            />
          }
        />
      </div>
    </div>
  )
}

export default ContrattoPage
